import { formati } from "../formati.ts";

const f = formati("it");

/** Il dettaglio di uno stack: configurazione, verifica, rilascio, container, storico. */
export const stack = {
  "verifica.impostaVariabile": "Imposta la variabile",
  "verifica.mostraEnvironment": "Mostra nell'environment",
  "verifica.apriImmagine": "Apri l'immagine nel compose",
  "verifica.apriNelCompose": "Apri nel compose",
  "verifica.conseguenza.MISSING_VARIABLE": "Il compose la userebbe vuota; se è obbligatoria (:?), l'avvio si fermerebbe.",
  "verifica.conseguenza.MISSING_TAG": "Non si potrebbe sapere quale versione è in esecuzione, né tornare indietro.",
  "verifica.conseguenza.MISSING_IMAGE": "Portman avvia stack da immagini già presenti in un registry.",
  "verifica.conseguenza.DUPLICATE_PORT": "Docker rifiuterebbe di avviare il secondo container.",
  "verifica.conseguenza.MUTABLE_TAG": "Il contenuto dell'immagine può cambiare senza preavviso.",
  "verifica.conseguenza.UNMANAGED_PORT": "La porta cambierebbe a ogni avvio, e con essa l'indirizzo del servizio.",
  "verifica.conseguenza.UNUSED_VARIABLE": "Nessun servizio la legge: probabilmente è un residuo.",
  "verifica.titolo.MISSING_VARIABLE": (p: { variabile: string }) => `La variabile ${p.variabile} non ha un valore`,
  "verifica.titolo.MISSING_TAG": (p: { servizio: string }) => `L'immagine di "${p.servizio}" non indica un tag`,
  "verifica.titolo.MISSING_IMAGE": (p: { servizio: string }) => `Il servizio "${p.servizio}" non dichiara un'immagine`,
  "verifica.titolo.DUPLICATE_PORT": "Due servizi chiedono la stessa porta host",
  "verifica.titolo.MUTABLE_TAG": (p: { servizio: string }) => `Il servizio "${p.servizio}" usa un tag mobile`,
  "verifica.titolo.UNMANAGED_PORT": (p: { servizio: string }) =>
    `Il servizio "${p.servizio}" lascia scegliere la porta a Docker`,
  "verifica.titolo.UNUSED_VARIABLE": (p: { variabile: string }) =>
    `La variabile ${p.variabile} non è usata dal compose`,
  "verifica.daRisolvere": "Da risolvere prima di avviare",
  "verifica.daValutare": "Da valutare",
  "verifica.bloccanti": (p: { n: number }) =>
    `${p.n} ${f.plurale(p.n, { one: "problema impedisce", other: "problemi impediscono" })} l'avvio`,
  "verifica.prontoDopoSalvataggio": "Pronto, una volta salvato",
  "verifica.pronto": "Pronto per l'avvio",
  "verifica.siFermerebbe": "L'avvio si fermerebbe prima di toccare Docker.",
  "verifica.usaUltimaRevisione": "L'avvio usa l'ultima revisione salvata: le correzioni vanno salvate per contare.",
  "verifica.avvisi": (p: { n: number }) => `Ci sono ${p.n} avvisi, che non bloccano l'avvio.`,
  "verifica.superati": "Controlli superati: variabili, immagini e porte.",
  "verifica.ricontrolla": "Ricontrolla",
  "verifica.tuttiRisolti": "tutti risolti",
  "verifica.risolto": "Risolto, da salvare per confermare.",
  "verifica.dettagli": "Dettagli",
  "verifica.valoreNascosto": "valore nascosto",
  "verifica.mostraPerModificare": "mostra per modificarlo",
  "verifica.segnaposto": "valore",
  "verifica.segnapostoPredefinito": (p: { valore: string }) => `${p.valore} (predefinito)`,
  "verifica.valoreDi": (p: { nome: string }) => `Valore di ${p.nome}`,
  "verifica.nomiOccupati": "Nomi di container già occupati",
  "verifica.nomeOccupato": (p: { nome: string; servizio: string; stato: string; progetto: string | null }) =>
    `${p.nome} (servizio ${p.servizio}) è già usato da un container ${p.stato}` +
    (p.progetto === null ? " avviato fuori da Compose" : ` del progetto Compose "${p.progetto}"`) +
    ".",
  "verifica.nomiSpiegazione":
    "I nomi fissati con container_name valgono su tutto il demone Docker, non solo dentro il progetto: " +
    "due stack non possono usarne uno uguale. Rimuovi i container che li occupano, oppure cambia i nomi in questo stack.",
  "verifica.porteOccupate": "Porte già occupate sull'host",
  "verifica.portaOccupata": (p: { porta: number; da: string }) => `La porta ${p.porta} è occupata da ${p.da}.`,
  "verifica.portaLibera": (p: { porta: number }) => `Libera: ${p.porta}.`,
  "verifica.interruzioneRicreazione": "circa un secondo, durante la ricreazione dei container",
  "verifica.interruzioneBlueGreen": "nessuna: il traffico si sposta quando la nuova versione è pronta",
  "verifica.cosaAccadra": "Cosa accadrà all'avvio",
  "verifica.immagini": "Immagini da scaricare",
  "verifica.porteAssegnate": "Porte assegnate da Portman",
  "verifica.nessuna": "nessuna",
  "verifica.interruzione": "Interruzione attesa",
  "verifica.daCorreggere": "da correggere",
  "verifica.daValutareBreve": "da valutare",
  "verifica.nessunaImmagine": "nessuna immagine",
  "verifica.soloInterna": "solo interna",
  "verifica.assegnataDaPortman": "assegnata da Portman",
  "verifica.auto": "auto",
  "verifica.senzaHealthcheckAiuto": "Senza healthcheck non si può attendere che il servizio sia pronto",
  "verifica.senzaHealthcheck": "senza healthcheck",
  "verifica.statoImpostata": "impostata",
  "verifica.statoPredefinito": "predefinito",
  "verifica.statoPortman": "da Portman",
  "verifica.statoMancante": "mancante",
  "verifica.valoriEnvironment": "Valori dell'environment",
  "verifica.variabiliCompose": "Variabili del compose",
  "verifica.mancanti": (p: { n: number }) => `${p.n} mancanti`,
  "verifica.modificaliQui": "Modificali qui: il salvataggio crea una revisione con tutte le modifiche insieme.",
  "verifica.daSalvare": "da salvare",
  "verifica.imposta": "Imposta",
  "verifica.modificate": (p: { n: number }) =>
    `${p.n} ${f.plurale(p.n, { one: "variabile modificata", other: "variabili modificate" })}`,
  "verifica.risolti": (p: { n: number }) =>
    `${p.n} ${f.plurale(p.n, { one: "problema risolto", other: "problemi risolti" })}`,
  "verifica.salvareNonAvvia": "Salvare crea una revisione e ricontrolla lo stack. Non avvia nulla.",
  "verifica.salvaRicontrolla": "Salva e ricontrolla",

  "container.filtroTutti": "Tutti",
  "container.filtroAvvisi": "Avvisi",
  "container.filtroErrori": "Errori",
  "container.live": "Live",
  "container.ogni5": "Ogni 5 s",
  "container.ogni10": "Ogni 10 s",
  "container.ogni30": "Ogni 30 s",
  "container.ogniMinuto": "Ogni minuto",
  "container.inPausa": "In pausa",
  "container.titolo": "Container",
  "container.aggiorna": "Aggiorna",
  "container.vuoto": "Nessun container",
  "container.vuotoAiuto": "Lo stack non è stato avviato su questo host.",
  "container.logDi": (p: { nome: string }) => `Log di ${p.nome}`,
  "container.mostraArrivate": "Mostra le righe arrivate",
  "container.righeNuove": (p: { n: number }) =>
    `${p.n} ${f.plurale(p.n, { one: "riga nuova", other: "righe nuove" })}`,
  "container.selezione": "selezione in corso",
  "container.inAscolto": "in ascolto",
  "container.concluso": "flusso concluso",
  "container.aggiornamento": "Aggiornamento dei log",
  "container.cercaSegnaposto": "Cerca nei log…",
  "container.cerca": "Cerca nei log",
  "container.nessunaRiga": "Nessuna riga di log.",
  "container.nessunaCorrisponde": "Nessuna riga corrisponde.",

  "console.rilascio": "Rilascio",
  "console.arresto": "Arresto",
  "console.riavvio": "Riavvio",
  "console.pull": "Aggiornamento delle immagini",
  "console.rinomina": "Rinomina",
  "console.operazione": "Operazione",
  "console.completato": "completato",
  "console.fallito": "fallito",
  "console.inCorso": "in corso",
  "console.faseNeiLog": (p: { indice: number; totale: number; titolo: string; durata: string }) =>
    `fase ${p.indice}/${p.totale} · ${p.titolo} (${p.durata})`,
  "console.fase": (p: { indice: number; totale: number; titolo: string }) =>
    `fase ${p.indice} di ${p.totale} · ${p.titolo}`,
  "console.in": (p: { durata: string }) => `in ${p.durata}`,
  "console.riconnessione": "collegamento ai log interrotto, torno a seguire l'operazione…",
  "console.annullo": "Annullo…",
  "console.riduci": "Riduci",
  "console.mostraLog": (p: { righe: number }) => `Mostra i log${p.righe ? ` (${p.righe})` : ""}`,
  "console.attesaRighe": "in attesa delle prime righe…",

  "schede.panoramica": "panoramica",
  "schede.risorse": "risorse",
  "schede.configurazione": "configurazione",
  "schede.rilascio": "rilascio",
  "schede.storico": "storico",
  "striscia.inEsecuzione": "In esecuzione",
  "striscia.blueGreen": "Blue/green",
  "striscia.ricreazione": "Ricreazione · ~1 s di interruzione",
  "striscia.sani": (p: { sani: number; totali: number }) => `${p.sani}/${p.totali} ok`,
  "striscia.fermo": "fermo",
  "panoramica.vuoto": "Lo stack non è ancora stato avviato",
  "panoramica.vuotoAiuto":
    "Qui compariranno container, log e consumi dopo il primo avvio. Prima controlla la configurazione.",
  "panoramica.vaiConfigurazione": "Vai alla configurazione",
  "dettaglio.generazioneAttiva": (p: { slot: string }) => `generazione ${p.slot} attiva`,
  "dettaglio.altreAzioni": "Altre azioni",
  "dettaglio.riavvia": "Riavvia",
  "dettaglio.rilascia": (p: { n: number }) => `Rilascia rev. ${p.n}`,
  "dettaglio.riprova": (p: { n: number }) => `Riprova rev. ${p.n}`,
  "dettaglio.modificaDescrizione": "Modifica la descrizione",
  "dettaglio.aggiungiDescrizione": "Aggiungi una descrizione",
  "dettaglio.descrizioneSegnaposto": "A cosa serve questo stack?",
  "dettaglio.descrizione": "Descrizione dello stack",
  "dettaglio.rinominaPrompt": (p: { nome: string; avviato: boolean }) =>
    `Nuovo nome per "${p.nome}".` +
    (p.avviato ? " Lo stack verrà fermato, i volumi copiati e poi riavviato: ci sarà un'interruzione." : ""),
  "dettaglio.rinomina": "Rinomina",
  "dettaglio.duplicaPrompt": (p: { nome: string }) =>
    `Nome della copia di "${p.nome}". Domini e porte non vengono copiati.`,
  "dettaglio.duplicaNome": (p: { nome: string }) => `${p.nome}-copia`,
  "dettaglio.duplica": "Duplica",
  "dettaglio.fermaPrima": "Ferma lo stack prima di eliminarlo",
  "dettaglio.eliminaConferma": (p: { nome: string }) =>
    `Eliminare "${p.nome}"? Configurazione, revisioni e storico andranno persi. I volumi Docker restano.`,
  "dettaglio.ferma": "Ferma",
  "dettaglio.avvia": "Avvia",
  "dettaglio.operazioneInCorso": (p: { operazione: string; attore: string | null }) =>
    p.operazione +
    (p.attore === null ? "" : p.attore === "webhook" ? " del webhook" : ` di ${p.attore}`) +
    " in corso: attendi che finisca.",
  "dettaglio.aiutoEditor": "Tab indenta · Invio mantiene il rientro",
  "dettaglio.salvaRevisione": "Salva revisione",
  "dettaglio.nessunaModifica": "Nessuna modifica",
  "dettaglio.sensibiliNascosti": "Valori sensibili nascosti",
  "dettaglio.mostraPerModificare": "Mostra per modificare",
  "dettaglio.messaggioRevisione": "Nome della versione (facoltativo)",
  "dettaglio.annullaModifiche": "Annulla modifiche",
  "dettaglio.nonSalvate": "Modifiche non salvate",

  "storico.ripristinareTitolo": (p: { numero: number }) => `Ripristinare la revisione #${p.numero}?`,
  "storico.ripristinareTesto":
    "Verrà salvata una nuova revisione con il suo contenuto. Con «Solo ripristino» lo stack continua a girare " +
    "con la configurazione attuale: la revisione ripristinata non sarà attiva finché non lo riavvii.",
  "storico.soloRipristino": "Solo ripristino",
  "storico.ripristinaAvvia": "Ripristina e avvia",
  "storico.revisioni": "Revisioni salvate",
  "storico.nessunaRevisione": "Nessuna revisione",
  "storico.senzaDescrizione": "senza descrizione",
  "storico.ripristina": "Ripristina",
  "storico.operazioni": "Operazioni eseguite",
  "storico.nessunaOperazione": "Nessuna operazione",
  "storico.rev": (p: { n: number }) => `rev. ${p.n}`,
  "storico.esitoRiuscita": "✓ riuscita",
  "storico.esitoFallita": "✗ fallita",
  "storico.esitoAnnullata": "annullata",
  "storico.esitoInCorso": "in corso",
  "storico.nessunLog": "Nessun log registrato.",
  "storico.cosaCambia": (p: { numero: number }) => `Cosa cambia da #${p.numero}`,
  "storico.completo": "Contenuto completo",
  "storico.nessunaVariabile": "Nessuna variabile.",
  "storico.invariato": "Invariato.",
  "storico.compose": "Compose",
  "storico.environment": "Environment",
  "storico.righeInvariate": (p: { n: number }) =>
    `${p.n} ${f.plurale(p.n, { one: "riga invariata", other: "righe invariate" })}`,

  "nuovo.composeEsempio":
    "services:\n" +
    "  web:\n" +
    "    image: nginx:${TAG}\n" +
    "    ports:\n" +
    "      # Scrivi la porta host come variabile: la assegna Portman,\n" +
    "      # e resta la stessa a ogni nuovo rilascio.\n" +
    '      - "${PORT_WEB}:80"\n' +
    "    restart: unless-stopped\n",
  "nuovo.messaggio": "creazione dello stack",
  "nuovo.intro": "Puoi salvare anche una configurazione incompleta: la verifica avviene all'avvio.",
  "nuovo.nome": "Nome",
  "nuovo.nomeAiuto": "Minuscole, cifre, trattini. Sarà il nome del progetto Docker Compose.",
  "nuovo.nomeSegnaposto": "mio-servizio",
  "nuovo.descrizione": "Descrizione (facoltativa)",
  "nuovo.titoloEditor": "Nuovo stack · docker-compose.yml",
  "nuovo.crea": "Crea stack",
};
